import { createRouter, createWebHistory } from 'vue-router'

const routes = [

    {
      path: "/",
      name: "home",
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/',
          name: 'home',
          component: () => import("../components/pages/HomeA.vue"),
        }
      ]
    },
    {
      path: "/about",
      name: "about",
      meta:{
        text: 'About Us',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/about',
          name: 'about',
          text: 'About Us',
          component: () => import("../components/pages/About.vue"),
        }
      ]
    },
    {
      path: "/speakers",
      name: "speakers",
      meta:{
        text: 'Speakers',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/speakers',
          name: 'speakers',
          component: () => import("../components/pages/Speakers.vue"),
        }
      ]
    },
    {
      path: "/schedules",
      name: "Schedules",
      meta:{
        text: 'Conference Schedules',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/schedules',
          name: 'Schedules',
          component: () => import("../components/pages/Schedules.vue"),
        }
      ]
    },

    {
      path: "/schedules-detail/:event_id/:date",
      name: "schedules-detail",
      meta:{
        text: 'Schedule Detail',
      },
      component: () => import('@/Layout/MainLayout.vue'),
      children:[
        {
          path: '/schedules-detail/:event_id/:date',
          name: 'SchedulesDayOne',
          
          component: () => import("@/components/singleComponent/ScheduleDetail.vue"),
        }
      ]
    },


    {
      path: "/gallery",
      name: "gallery",
      meta:{
        text: 'Gallery',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/gallery',
          name: 'gallery',
          component: () => import("../components/pages/Gallery.vue"),
        }
      ]
    },
    {
      path: "/videos",
      name: "videos",
      meta:{
        text: 'Videos',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/videos',
          name: 'videos',
          component: () => import("../components/pages/VideoGallery.vue"),
        }
      ]
    },
    {
      path: "/marketplace",
      name: "marketplace",
      meta:{
        text: 'Marketplace',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/marketplace',
          name: 'marketplace',
          component: () => import("../components/pages/Marketplace.vue"),
        }
      ]
    },
    {
      path: "/contact",
      name: "contact",
      meta:{
        text: 'Contact Us',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/contact',
          name: 'contact',
          component: () => import("../components/pages/Contact.vue"),
        }
      ]
    },
    {
      path: "/seminar",
      name: "seminar",
      meta:{
        text: 'seminar',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/seminar',
          name: 'seminar',
          component: () => import("../components/pages/Seminar.vue"),
        }
      ]
    },
    {
      path: "/workshop",
      name: "workshop",
      meta:{
        text: 'workshop',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/workshop',
          name: 'workshop',
          component: () => import("../components/pages/Workshop.vue"),
        }
      ]
    },
    {
      path: "/symposiums",
      name: "symposiums",
      meta:{
        text: 'symposiums',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/symposiums',
          name: 'symposiums',
          component: () => import("../components/pages/Symposiums.vue"),
        }
      ]
    },
    {
      path: "/conference",
      name: "conference",
      meta:{
        text: 'conference',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/conference',
          name: 'conference',
          component: () => import("../components/pages/Conference.vue"),
        }
      ]
    },
    {
      path: "/course",
      name: "course",
      meta:{
        text: 'Certificate Course',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/course',
          name: 'course',
          component: () => import("../components/pages/CertificateCourse.vue"),
        }
      ]
    },    
    {
      path: "/registration/:event_id",
      name: "registration",
      meta:{
        text: 'Registration',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/registration/:event_id',
          name: 'registration',
          component: () => import("../components/pages/Registration.vue"),
        }
      ]
    }, 
    {
      path: "/speaker_registration/:event_id",
      name: "speaker_registration",
      meta:{
        text: 'Speaker Registration',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/speaker_registration/:event_id',
          name: 'speaker_registration',
          component: () => import("../components/pages/SpeakerRegistration.vue"),   
        }
      ]
    },
    {
      path: "/registration-terms-and-condition",
      name: "registration-terms-and-condition",
      meta:{
        text: 'Terms & Conditions',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/registration-terms-and-condition',
          name: 'registration-terms-and-condition',
          component: () => import("../components/pages/TermsAndConditions.vue"),
        }
      ]
    },
    {
      path: "/registration-terms-and-condition-virtual",
      name: "registration-terms-and-condition-virtual",
      meta:{
        text: 'Terms & Conditions',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/registration-terms-and-condition-virtual',
          name: 'registration-terms-and-condition-virtual',
          component: () => import("../components/pages/TermsAndConditionsForVirtual.vue"),
        }
      ]
    },
    {
      path: "/reports",
      name: "reports",
      meta:{
        text: 'Reports',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/reports',
          name: 'reports',
          component: () => import("../components/pages/Reports.vue"),
        }
      ]
    },  
    {
      path: "/documents",
      name: "documents",
      meta:{
        text: 'Documents',
      },
      component: () => import('../Layout/MainLayout.vue'),
      children:[
        {
          path: '/documents',
          name: 'documents',
          component: () => import("../components/pages/Documents.vue"),
        }
      ]
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta:{
        text: 'Dashboard',
      },
      component: () => import('../Layout/DashboardLayout.vue'),
      children:[
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import("../components/dashboard/Dashboard.vue"),
        }
      ]
    },  
    {
      path: "/profile",
      name: "profile",
      meta:{
        text: 'Profile',
      },
      component: () => import('../Layout/DashboardLayout.vue'),
      children:[
        {
          path: '/profile',
          name: 'profile',
          component: () => import("../components/dashboard/Profile.vue"),
        }
      ]
    },  
    
    {
      path: "/event/:id",
      name: "eventDetail",
      meta:{
        text: 'Event Detail',
      },
      component: () => import('@/Layout/MainLayout.vue'),
      children:[
        {
          path: '/event/:id',
          name: 'eventDetail',
          component: () => import("@/components/pages/EventDetail.vue"),
        }
      ]
    }, 





    { 
      path: '/:pathMatch(.*)*', 
      component: () => import('../components/pages/404.vue'),
    },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  
});


router.beforeEach((to, from, next) => {
  //console.log(`Navigating to: ${to.name}`);
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
  next();
});
export default router;
